<script setup>
import {computed, ref} from "vue";
import {useDisplay} from "vuetify/framework";
import {useI18n} from "vue-i18n";

const pgShow = ref(false);

const { locale } = useI18n()

const partners = computed(() => [
  {
    id: 1,
    name: 'aitu browser',
    logo: '/img/partners/aitu.svg',
    href: 'https://aitubrowser.kz/?utm_source=partner&utm_medium=b2b-telecom'
  },
  {
    id: 2,
    name: '2ГИС',
    logo: '/img/partners/2gis.svg',
    href: 'https://dev.2gis.ru/pro?utm_source=partner&utm_medium=b2b-telecom&utm_campaign=2gispro'
  },
  {
    id: 3,
    name: 'Кабинет досудебных претензий',
    logo: `/img/partners/kdp_${locale.value === 'en' || locale.value === 'kk' ? 'kk.png' : 'ru.svg'}`,
    href: 'https://ekdp.kz/ru?utm_source=partner&utm_medium=b2b-telecom'
  },
  {
    id: 4,
    name: 'Публичная кадастровая карта',
    logo: `/img/partners/pkk_${locale.value}.svg`,
    href: 'https://map.gov4c.kz/egkn/?utm_source=partner&utm_medium=b2b-telecom'
  },
  {
    id: 5,
    name: 'Правительство для граждан',
    logo: `/img/partners/pg_${locale.value}.svg`,
    pgModal: true,
  }
])
const {xs} = useDisplay();
const openPgModal = () => {
  if(xs.value){
    window.open('https://onelink.to/5nb5yx', '_blank');
  } else{
    pgShow.value = true;
  }
}
</script>

<template>
  <section class="partners">
    <div class="partners__inner">
      <div class="partners__scroller">
        <div class="partners__list">
          <template v-for="item in partners" :key="item.id">
            <a class="partners__item" :href="item.href" target="_blank" v-if="!item.pgModal">
              <img :src="item.logo" :alt="item.name"/>
            </a>
            <div class="partners__item" v-else @click="openPgModal">
              <img :src="item.logo" :alt="item.name"/>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>

  <BaseModal v-model="pgShow" title="" position="top" background="#fff" max-width="465px">
    <div class="d-flex flex-column align-center w-100">
      <div class="title">{{$t('Скачайте приложение')}}</div>
      <div class="sub-title">{{$t('Отсканируйте QR-код камерой телефона')}}</div>
      <img width="200" height="200" src="/img/partners/con-qr.png" :alt="$t('Правительство для граждан')"/>
    </div>
  </BaseModal>
</template>

<style scoped lang="scss">
.partners {
  width: 100%;
  background: $color-primary;
  height: 147px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__inner {
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
  }

  &__scroller {
    width: 100%;
  }

  &__list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    flex-shrink: 0;
    cursor: pointer;

    img {
      transition: all .3s;
      max-height: 100%;
      max-width: 140px;
      object-fit: contain;
      &:hover {
        transform: scale(1.1);
      }
    }
  }


}

.title {
  font-size: 20px;
  font-weight: 500;
  line-height: 130%;
  margin-bottom: 12px;
  text-align: center;
}
.sub-title {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: .14px;
  text-align: center;
  margin-bottom: 29px;
}

@media (max-width: 1440px) {
  .partners {
    padding: 0 80px;
  }
}

@media (max-width: 1280px) {
  .partners__list {
    gap: 0
  }
}

@media (max-width: 1024px) {
  .partners {
    padding: 0 64px;
    &__item {
      height: 140px;
      img {
        max-width: 108px;
      }
    }
  }
}

@media (max-width: 700px) {
  .partners {
    padding: 26px 0;

    &__inner {
      max-width: none;
      margin: 0;
      overflow: hidden;
    }

    &__scroller {
      overflow-x: auto;
      overflow-y: hidden;
      padding: 0 24px;
      box-sizing: border-box;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &__list {
      width: max-content;
      flex-wrap: nowrap;
      justify-content: flex-start;
      gap: 24px;
    }

    &__item {
      height: 58px;
      padding: 0;
      flex: 0 0 auto;

      img {
        max-width: 150px;
        max-height: 52px;
      }
    }
  }
}
</style>
